import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { SocialMediaJobStatuses } from "@shared/lib/types/influencer";
import { ISocialMediaInfluencerV2 } from "@shared/lib/types/socialMediaInfluencerV2";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { InfluencerService } from "../services/influencer.service";

export function useGetSocialMediaInfluencerV2(socialMediaId: string) {
  const { data, isLoading, isError, error, refetch } = useQuery<
    BackednResponse<ISocialMediaInfluencerV2>
  >({
    queryKey: [...INFLUENCER_LIST_QUERY_KEY, "social-media-v2", socialMediaId],
    queryFn: () => InfluencerService.getSocialMedia(socialMediaId),
    enabled: !!socialMediaId,
    refetchInterval: (query) => {
      if (query.state.data?.data.socialMedia.creatorProfileJob?.status === SocialMediaJobStatuses.Completed || query.state?.data?.data?.socialMedia?.creatorProfileJob?.status === SocialMediaJobStatuses.Failed || !query.state?.data?.data?.socialMedia?.creatorProfileJob) {
        return false;
      }
      return 40000;
    },
  });

  useEffect(() => {
    const errorMessage = isError && error?.message;
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [isError, error]);

  return {
    socialMediaInfluencer: data?.data,
    isFetching: isLoading,
    isError,
    refetch,
  };
}
